import { inject } from '@angular/core'
import { ResolveFn } from '@angular/router'
import { PostLoaderService } from '../shared/data-loaders/post-loader/post-loader.service'

export const SinglePostResolver: ResolveFn<any> = (route, state) => {
  const dataService = inject(PostLoaderService)
  const postId = route.paramMap.get('postID')
  return postId ? dataService.loadPost(postId) : null
}
